export const state = () => ({
	subscription: {},
})

export const actions = {
	async retrieve({ commit }, { companyId }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/shopify-subscriptions/`)
			.then((res) => {
				let subscription = {}
				if (res.count > 0) {
					subscription = res.results.find((sub) => sub.status === 'ACTIVE')
				}
				commit('setSubscription', subscription || {})
				return subscription
			})
			.catch((err) => {
				commit('setSubscription', {})
				throw err
			})
	},

	async create({ commit }, { companyId, planId, orderPricingRange }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/shopify-subscriptions/`, {
				method: 'POST',
				body: {
					plan_id: planId,
					plan_range_name: orderPricingRange,
				},
			})
			.then((subscription) => {
				commit('setSubscription', subscription)
				return subscription
			})
	},
	async createCustom({ commit }, { companyId, maxOrders, price, overage, periodicity }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/shopify-subscriptions/`, {
				method: 'POST',
				body: {
					recurring_price: price,
					overage_price: overage,
					max_orders: maxOrders,
					plan_id: 9,
					payment_period: periodicity,
				},
			})
			.then((subscription) => {
				commit('setSubscription', subscription)
				return subscription
			})
	},
}

export const mutations = {
	setSubscription(state, subscription) {
		state.subscription = subscription
	},
}
